import React, { FC, useState } from 'react';
import { useHistory } from 'react-router';

import CreditReleaseOperationsHistory from '../../containers/operations-history/credit-release-operations-history';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';
import { CreditConstraintsResponse } from '../../services/api/dto/Credits';
import AssetsCreditForm from '../forms/assets-credit-form/assets-credit-form';

interface AssetsCreditProps {
  constraints?: CreditConstraintsResponse;
  loadingConstraints?: boolean;
}

const AssetsCredit: FC<AssetsCreditProps> = ({
  constraints,
  loadingConstraints,
}) => {
  const history = useHistory();
  const [value, setValue] = useState<number>();
  const [period, setPeriod] = useState<number>();
  const onRefresh = (val: number, period?: number) => {
    setValue(val);
    setPeriod(period);
  };

  return (
    <TableWrapper>
      <div className="assets">
        <div className="assets__header">
          <TableHeaderWrapper
            leftContent="Заём цифровых финансовых активов"
            onCloseClick={() => history.replace('/assets')}
          />
        </div>
        <div className="assets__body">
          <div className="row">
            <div className="col-19 col-lg-27 col-xl-14">
              <AssetsCreditForm
                value={value}
                period={period}
                constraints={constraints}
                loadingConstraints={loadingConstraints}
              />
            </div>
            <div className="col-19 col-lg-27 col-xl-18">
              <CreditReleaseOperationsHistory onRefresh={onRefresh} />
            </div>
          </div>
        </div>
      </div>
    </TableWrapper>
  );
};

export default AssetsCredit;
